import { assetRoutes } from "./assets/asset.routes";
import { blogRoutes } from "./blog/blog.routes";
import { generalRoutes } from "./general/general.routes";
import Layout from "../../Layout";
import NotFoundPage from "../../pages/404";
import ErrorPage from "../../components/UI/ErrorPage";

export const siteRouter = [
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      ...generalRoutes,
      ...assetRoutes,
      ...blogRoutes,
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];
